import React from 'react'
import { Box, styled, SvgIconTypeMap, SxProps, useTheme } from '@mui/material'
import { colors } from '../constants/colors'
import { pageState } from '../context/page-context'
import { CustomIconProps } from '../types/component-types'
import { OverridableComponent } from '@mui/material/OverridableComponent'

type IconTagProps = {
  Icon: ((props: CustomIconProps) => JSX.Element) | (OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    displayName: string;
  })
  variant?: 'primary' | 'info'
  sx?: SxProps
}

const SIZE_CONFIG_IN_PX = {
  mobile: { icon: 21, tag: 36 },
  desktop: { icon: 24, tag: 50 }
}

const IconTag = ({ Icon, variant = 'primary', sx }: IconTagProps) => {
  const { isMobile } = pageState()
  const theme = useTheme()
  const sizeConfig = isMobile ? SIZE_CONFIG_IN_PX.mobile : SIZE_CONFIG_IN_PX.desktop
  const bgColor = variant === 'primary' ? theme.palette.primary.main : colors.BLACK_10
  const iconColor = variant === 'primary' ? colors.WHITE : colors.BLACK_100

  return (
    <IconContainer
      bgcolor={bgColor}
      width={sizeConfig.tag}
      height={sizeConfig.tag}
      sx={{ "& svg": { fontSize: sizeConfig.icon }, ...(sx ? sx : {}) }}
    >
      {'displayName' in Icon ?
        <Icon sx={{ color: iconColor, fontSize: sizeConfig.icon }} /> :
        <Icon color={iconColor} size={sizeConfig.icon} />}
    </IconContainer>
  )
}

const IconContainer = styled(Box)`
  display: flex;
  border-radius: 14px;
  align-items: center;
  justify-content: center;
  ${({ theme }) => `
    ${theme.breakpoints.down('md')} {
      border-radius: 10px;
    }
  `}
`

export default IconTag
